export const FICHES = {
  "IND-UT-102": {
    reference: "IND-UT-102",
    version: "vA19-2",
    label: "Système de variation électronique de vitesse sur un moteur asynchrone",
    shortLabel: "Variateur de vitesse sur moteur asynchrone",
    puissanceMax: 3000,
    dureeVie: 15,
    coefficients: { pompage: 12400, ventilation: 12200, air_comprime: 11900, frigorifique: 7100, autre: 5500 },
    designation:
      "Mise en place d'un système de variation électronique de vitesse sur un moteur asynchrone, réalisée conformément à la fiche d'opération standardisée des certificats d'économies d'énergie (CEE) IND-UT-102 « Système de variation électronique de vitesse sur un moteur asynchrone », version en vigueur.",
  },
  "IND-UT-114": {
    reference: "IND-UT-114",
    version: "v A24-2",
    label: "Mise en place d'un moto-variateur synchrone à aimants permanents ou à réluctance",
    shortLabel: "Moto-variateur synchrone (aimants permanents / réluctance)",
    puissanceMax: 1000,
    dureeVie: 20,
    coefficients: { pompage: 17800, ventilation: 17600, air_comprime: 9200, frigorifique: 14500, autre: 11400 },
    designation:
      "Mise en place d'un moto-variateur synchrone à aimants permanents ou à réluctance, réalisée conformément à la fiche d'opération standardisée des certificats d'économies d'énergie (CEE) IND-UT-114 « Mise en place d'un moto-variateur synchrone à aimants permanents ou à réluctance », version en vigueur.",
  },
  "IND-UT-132": {
    reference: "IND-UT-132",
    version: "vA26-1",
    label: "Moteur asynchrone de classe IE4",
    shortLabel: "Moteur asynchrone IE4 (norme CEI 60034-30-1)",
    puissanceMax: 1000,
    puissanceMin: 0.12,
    dureeVie: null,
    special: "ie4",
    coefficients: null,
    designation:
      "Mise en place d'un moteur asynchrone de classe IE4 selon la norme CEI 60034-30-1, réalisée conformément à la fiche d'opération standardisée des certificats d'économies d'énergie (CEE) IND-UT-132 « Moteur asynchrone de classe IE4 », version en vigueur. Le volume est déterminé par la formule de la fiche selon la puissance utile P du moteur (0,12 kW ≤ P ≤ 0,75 kW : 4 900 × P + 2 600 ; 0,75 kW < P ≤ 375 kW : 700 × P + 12 000 ; 375 kW < P ≤ 1 000 kW : 1 600 × P), multiplié par le nombre de moteurs concernés.",
  },
};

export const APPLICATIONS = {
  pompage: "Pompage",
  ventilation: "Ventilation",
  air_comprime: "Air comprimé",
  frigorifique: "Compression frigorifique",
  autre: "Autre application",
};

export const DOC_TYPES = ["Devis à envoyer", "Devis signé", "Facture", "Attestation sur l'honneur", "Rapport COFRAC", "Autre"];
export const REQUIRED_DOC_TYPES = ["Devis à envoyer", "Devis signé", "Facture", "Attestation sur l'honneur"];
export const STATUTS = ["En création", "Devis envoyé", "Devis validé", "En instruction", "Validé", "Réglé", "Mise en conformité"];

export const STATUT_INFOS = {
  "En création": "Dossier créé dans le portail ; chiffrage et constitution du dossier en cours.",
  "Devis envoyé": "Devis transmis au client : la pièce « Devis à envoyer » a été validée.",
  "Devis validé": "Devis signé reçu et validé ; les travaux sont en cours ou programmés.",
  "En instruction": "Facture et attestation sur l'honneur reçues : le dossier est en cours de contrôle.",
  "Validé": "Tous les documents obligatoires sont validés ; l'appel à facturation est en cours.",
  "Réglé": "La prime CEE et la commission sont réglées.",
  "Mise en conformité": "Un document a été refusé : le dossier doit être remis en conformité et la pièce corrigée redéposée sur le portail.",
};

export const PRIX_CLIENT_MAX = 6;
export const PRIX_CLIENT_MIN = 5.3;

/* Mode de versement de la prime CEE — choix obligatoire du partenaire avant enregistrement du dossier */
export const VERSEMENT_PRIME_OPTIONS = [
  {
    value: "direct_client",
    label: "Prime direct bénéficiaire",
    short: "Direct bénéficiaire",
    hint: "La prime CEE sera versée directement au bénéficiaire des travaux.",
  },
  {
    value: "remise_sur_devis",
    label: "Prime en remise sur devis",
    short: "Remise sur devis",
    hint: "La prime CEE sera versée à Thionnet et viendra en remise sur le devis.",
  },
];
export const VERSEMENT_PRIME_LABELS = Object.fromEntries(VERSEMENT_PRIME_OPTIONS.map((o) => [o.value, o.short]));

export const DEFAULT_PRICING = {
  prixAutre: 6,
  paliers: [
    { seuilKwhCumac: 8000000, prix: 7 },
    { seuilKwhCumac: 3000000, prix: 6.5 },
  ],
};

export const MENTIONS_CEE =
  "Les opérations ci-dessus sont éligibles au dispositif des certificats d'économies d'énergie (CEE), au titre de la ou des fiches IND-UT-102 et/ou IND-UT-114 mentionnées pour chacune. Le montant de la prime CEE indiqué ci-dessus est estimatif ; il sera confirmé à l'issue du contrôle de conformité du dossier par l'obligé partenaire, sur la base des justificatifs de réalisation de chaque opération (facture, attestation sur l'honneur et preuve de réalisation conformes aux exigences de la fiche applicable à chacune, en vigueur). Conformément à la réglementation, les travaux ne doivent pas débuter avant la date d'engagement de l'opération concernée, déterminée séparément selon les modalités applicables.";

export const CONDITIONS_CEE = [
  (validite) => `Estimation établie à titre indicatif et informatif, sans valeur contractuelle, valable ${validite} jours à compter de sa date d'émission.`,
  "Document établi à titre indicatif et informatif ; il ne constitue pas un engagement contractuel. Les montants de prime CEE restent soumis à la vérification définitive des conditions d'éligibilité de la ou des fiches en vigueur au moment de l'engagement de chaque opération.",
];

export function prixSelonVolume(totalKwhCumac, pricing = DEFAULT_PRICING) {
  const paliers = [...(pricing.paliers || [])].sort((a, b) => b.seuilKwhCumac - a.seuilKwhCumac);
  for (const p of paliers) {
    if (totalKwhCumac > p.seuilKwhCumac) return p.prix;
  }
  return pricing.prixAutre ?? 6;
}

export function volumeKwh(op) {
  const fiche = FICHES[op.fiche];
  if (!fiche) {
    // Fiche hors catalogue (dossier historique importé) : volume figé sur l'opération
    return { kwh: parseFloat(op.kwhCumac) || 0, coef: null, issues: [] };
  }
  const puissance = parseFloat(op.puissance) || 0;
  if (fiche.special === "ie4") {
    const nb = Math.max(parseInt(op.nbMoteurs, 10) || 1, 1);
    const issues = [];
    if (0 < puissance && puissance < fiche.puissanceMin)
      issues.push(`la puissance utile du moteur est inférieure au minimum de ${fiche.puissanceMin} kW applicable à la fiche ${fiche.reference}`);
    if (puissance > fiche.puissanceMax)
      issues.push(`la puissance utile du moteur dépasse le plafond de ${fiche.puissanceMax} kW applicable à la fiche ${fiche.reference}`);
    let kwh = 0;
    if (0 < puissance && puissance <= 0.75) kwh = 4900 * puissance + 2600;
    else if (puissance > 0.75 && puissance <= 375) kwh = 700 * puissance + 12000;
    else if (puissance > 375) kwh = 1600 * puissance;
    return { kwh: kwh * nb, coef: null, issues };
  }
  const coef = fiche.coefficients[op.application] || 0;
  return { kwh: coef * puissance, coef, issues: [] };
}

export function computeOperation(op, prixCession) {
  const fiche = FICHES[op.fiche];
  const isIe4 = !!fiche?.special;
  const { kwh: kwhCumac, coef, issues } = volumeKwh(op);
  const puissance = parseFloat(op.puissance) || 0;
  const mwhCumac = kwhCumac / 1000;
  if (puissance <= 0)
    issues.unshift(
      isIe4
        ? "la puissance utile du moteur doit être renseignée et supérieure à 0"
        : "la puissance nominale totale doit être renseignée et supérieure à 0"
    );
  else if (!isIe4 && fiche && puissance > fiche.puissanceMax)
    issues.push(`la puissance nominale totale dépasse le plafond de ${fiche.puissanceMax} kW applicable à la fiche ${op.fiche}`);
  const dureeVie = isIe4 ? (puissance > 0 ? (puissance <= 15 ? 15 : 20) : null) : fiche?.dureeVie ?? null;
  return { coef, kwhCumac, mwhCumac, prime: mwhCumac * prixCession, puissance, dureeVie, special: isIe4 ? "ie4" : null, issues };
}

export function computeDossier(ops, { prixOverride = false, prixMwh = 0, prixCession = PRIX_CLIENT_MAX } = {}, pricing = DEFAULT_PRICING) {
  const totalKwhForPricing = ops.reduce((acc, op) => acc + volumeKwh(op).kwh, 0);
  const prixAuto = prixSelonVolume(totalKwhForPricing, pricing);
  const prixReel = prixOverride ? parseFloat(prixMwh) || 0 : prixAuto;

  // Valorisation visible côté client (curseur 5,3 – 6 €/MWh) ; le prix réel du marché est masqué.
  // Dossier avec une opération hors catalogue à volume figé : valorisation historique conservée sans écrêtage.
  const volumeFige = ops.some((op) => !FICHES[op.fiche] && (parseFloat(op.kwhCumac) || 0) > 0);
  const cession = volumeFige
    ? parseFloat(prixCession) || PRIX_CLIENT_MAX
    : Math.min(PRIX_CLIENT_MAX, Math.max(PRIX_CLIENT_MIN, parseFloat(prixCession) || PRIX_CLIENT_MAX));

  const results = ops.map((op) => computeOperation(op, cession));
  const totalPuissance = results.reduce((a, r) => a + r.puissance, 0);
  const totalKwh = results.reduce((a, r) => a + r.kwhCumac, 0);
  const primeCession = results.reduce((a, r) => a + r.prime, 0);
  const mwhTotal = totalKwh / 1000;
  const commissionTotal = Math.max(0, (PRIX_CLIENT_MAX - cession) * mwhTotal);
  const primeBrute = mwhTotal * prixReel;
  const motifs = results.flatMap((r, i) => r.issues.map((m) => `Opération ${i + 1} : ${m}.`));

  return {
    results,
    totals: {
      nbOperations: ops.length,
      puissanceTotale: totalPuissance,
      kwhCumacTotal: totalKwh,
      mwhCumacTotal: mwhTotal,
      prixCession: cession,
      prixApplique: prixReel,
      prixAuto,
      prixOverride: !!prixOverride,
      primeCessionTotal: primeCession,
      commissionTotal,
      primeBrute,
      margeInterne: primeBrute - primeCession - commissionTotal,
      primeNette: primeCession,
      eligible: motifs.length === 0,
      motifs,
    },
  };
}

export function fmt(n, decimals = 0) {
  if (n === null || n === undefined || Number.isNaN(Number(n))) return "—";
  return Number(n).toLocaleString("fr-FR", {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
}

export function euros(n, decimals = 0) {
  return `${fmt(Math.round(n * 10 ** decimals) / 10 ** decimals, decimals)} €`;
}
